export default __webpack_public_path__ + "static/media/google.e1bd93aa.png";